import { useState } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import { RiAddFill } from 'react-icons/ri';
import { useAuthContext } from '@contexts/auth';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';

import useGetList from './useGetList';
import AddDialog from './components/AddDialog';
import CampaignCard from './components/CampaignCard';
import Header from './components/Header';

const Campaign = () => {
  const { checkIfHasRole } = useAuthContext();

  const [showAddDialog, setShowAddDialog] = useState(false);
  const {
    getCampaigns,
    campaigns,
    loading,
    totalPages,
  } = useGetList();

  const getCurrentComponent = () => {
    if (loading) return <Loading />;
    
    if (campaigns.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhuma campanha encontrada.
        </Box>
      );
    }

    return (
      <PaginationRouterContainer
        total={totalPages}
        onPaginationChange={getCampaigns}
      >
        {campaigns.map((campaign) => (
          <CampaignCard
            key={campaign.id}
            campaign={campaign}
            refetch={() => getCampaigns({})}
          />
        ))}
      </PaginationRouterContainer>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={8}>
        <Header />
        {checkIfHasRole('CAN_CREATE_CAMPAIGNS') && (
          <Button size="sm" onClick={() => setShowAddDialog(true)}>
            <RiAddFill /> Nova
          </Button>
        )}
      </Flex>

      {getCurrentComponent()}

      {showAddDialog && (
        <AddDialog
          handleClose={() => setShowAddDialog(false)}
          afterSubmit={() => getCampaigns({})}
        />
      )}
    </Box>
  );
};

export default Campaign;
